import CustomDataTable from './CustomDataTable';
import CustomCell from './CustomCell';

export { CustomCell };

export default CustomDataTable;
